module.exports = __webpack_public_path__ + "static/media/arrowdownselect2.2ed7deb9.svg";